import { useBetween } from '../shared/use-between/use-between';
import { useEffect } from 'react';
import { StpViewerUseBetween } from './use-between/stp-viewer-use-between';
import { getStpViewerConfig } from '../shared/services/local-storage/latest-items-usage.service';

export default function StpViewerInitialize() {
    const { set3dMode } = useBetween(StpViewerUseBetween);

    const handle3dMode = () => {
        set3dMode(getStpViewerConfig().is3dMode);
    };
    useEffect(() => {
        handle3dMode();
    }, []);

    return <></>;
}
